<template>
  <v-row no-gutters>
    <v-col>
      <v-card flat outlined class="my-1" :class="order.Id ? '' : 'potentialorder'">
        <v-card flat class="pa-3 hidecaret" color="transparent" :ripple="false" @click.stop="collapsed = !collapsed">
          <v-row no-gutters align="center">
            <v-col cols="2">
              {{ i18nFormatDate(order.CreatedDate) }}
            </v-col>
            <v-col cols="2">
              <template v-if="order.Id">
                #{{ order.Id }}
              </template>
              <template v-else>
                <v-btn small outlined color="primary">
                  Generate order
                </v-btn>
              </template>
            </v-col>
            <v-col cols="4">
              {{ order.CustomerId }} {{ order.CustomerName }}
            </v-col>
            <v-col class="d-flex justify-end pr-3">
              {{ formatCurrencyTotal(totalAmount) }}
            </v-col>
            <v-col cols="1" class="d-flex justify-end">
              <v-btn small icon @click.stop="collapsed = !collapsed">
                <v-icon v-text="collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'"></v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <template v-if="!collapsed">
          <v-divider></v-divider>
          <v-row no-gutters style="background-color: rgb(0 0 0 / 1%);" class="px-3 pb-3">
            <v-col>
              <v-row no-gutters class="py-1 mt-1" style="border-bottom: 1px solid rgb(0 0 0 / 20%);">
                <v-col cols="2">
                  Article
                </v-col>
                <v-col cols="0">
                  Text
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                  Qty
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  Unit price
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  Line total
                </v-col>
              </v-row>
              <v-row v-for="detail in order.OrderDetails" :key="detail.Id" no-gutters class="py-1"
                style="border-bottom: 1px solid rgb(0 0 0 / 6%);">
                <v-col cols="2">
                  {{ detail.ArticleNumber }}
                </v-col>
                <v-col cols="0" class="nowrapheader">
                  {{ detail.ArticleDescription }}
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                  {{ detail.ArticleCount }} x
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  {{ formatCurrencyTotal(detail.ArticlePrice) }}
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  {{ formatCurrencyTotal(detail.TotalAmountExclVat) }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="0">
                </v-col>
                <v-col class="d-flex justify-end pt-3" cols="auto">
                  <p class="ma-0 mr-3">Order total:</p>
                  {{ formatCurrencyTotal(order.TotalAmountExclVat) }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: 'ContractOrderCard',
  props: {
    order: Object,
  },
  components: {},

  data() {
    return {
      collapsed: true,
    };
  },

  methods: {},

  computed: {
    totalAmount() {
      return (this.order?.TotalAmountExclVat || 0) - (this.order?.TotalDiscount || 0);
    }
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.hidecaret.v-card--link:before {
  background: none;
  background-color: transparent;
}

.potentialorder {
  border: 1px dashed #9e9e9e !important;
  background-color: rgba(255, 255, 255, 0.641);
}
</style>